import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { GetDoDataImpParams } from '@app/services/do-data-imp.service';

@Component({
    selector: 'tt-do-data-imp-view',
    templateUrl: './do-data-imp-view.component.html',
    styleUrls: ['./do-data-imp-view.component.css'],
})
export class DoDataImpViewComponent {
    public params: GetDoDataImpParams;

    constructor(private state: StateService) {
        this.params = state.getStateParams() as unknown as GetDoDataImpParams;
    }
}
